import React from 'react'
import { Link } from 'react-router-dom'
import Bredcrumb from '../Common/Bredcrumb'

const PlacementRecord202526 = () => {
  return (
    <>
    <Bredcrumb title="Placement Record 2024-25" />
    <section className='mt-4'>
          <div class="container">
              <div class="row">
                  <div class="col-lg-8">
                       <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>S.N.</th>
                                    <th>NAME OF STUDENTS</th>
                                    <th>DEPARTMENT</th>
                                    <th>COMPANY</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>1.</td>
                                <td>Yogesh Yadav</td>
                                <td>Marketing Executive</td>
                                <td>Mabril Healthcare Ltd.</td>
                            </tr>
                            <tr>
                                <td>2.</td>
                                <td>Uttam Yadav</td>
                                <td>Marketing Executive</td>
                                <td>Mabril Healthcare Ltd.</td>
                            </tr>
                            <tr>
                                <td>3.</td>
                                <td>Sadab Khan</td>
                                <td>Mabril Healthcare Ltd.</td>
                                <td>Marketing Executive</td>
                            </tr>
                            <tr>
                                <td>4.</td>
                                <td>Priyanshu Pal </td>
                                <td>Business Executive</td>
                                <td>Cadilla Pharmaceutical Ltd.</td>
                            </tr>
                            <tr>
                                <td>5.</td>
                                <td>Israfil Ansari </td>
                                <td>Business Executive</td>
                                <td>Cadilla Pharmaceutical Ltd.</td>
                            </tr>
                            <tr>
                                <td>6.</td>
                                <td>Abhishek Yadav</td>
                                <td>Business Executive</td>
                                <td>Cadilla Pharmaceutical Ltd.</td>
                            </tr>
                            <tr>
                                <td>7.</td>
                                <td>Sajid Hussain</td>
                                <td>Business Executive</td>
                                <td>Cadilla Pharmaceutical Ltd.</td>
                            </tr>
                            <tr>
                                <td>8.</td>
                                <td>Diwakar Patel</td>
                                <td>Business Executive</td>
                                <td>Cadilla Pharmaceutical Ltd.</td>
                            </tr>
                            <tr>
                                <td>9.</td>
                                <td>Deepak Gupta </td>
                                <td>Business Executive</td>
                                <td>Eris Lifescience Pvt. Ltd.</td>
                            </tr>
                            <tr>
                                <td>10.</td>
                                <td>Shiva Singh</td>
                                <td>Business Executive</td>
                                <td>Eris Lifescience Pvt. Ltd.</td>
                            </tr>
                            <tr>
                                <td>11.</td>
                                <td>Abhit Sharma</td>
                                <td>Business Executive</td>
                                <td>Eris Lifescience Pvt. Ltd.</td>
                            </tr>
                            <tr>
                                <td>12.</td>
                                <td>Amit Gupta</td>
                                <td>Business Executive</td>
                                <td>Eris Lifescience Pvt. Ltd.</td>
                            </tr>
                            <tr>
                                <td>13.</td>
                                <td>Atul Gupta</td>
                                <td>Business Executive</td>
                                <td>Eris Lifescience Pvt. Ltd.</td>
                            </tr>
                            <tr>
                                <td>14.</td>
                                <td>Prasoon Rai</td>
                                <td>Business Executive</td>
                                <td>Eris Lifescience Pvt. Ltd.</td>
                            </tr>
                            <tr>
                                <td>15.</td>
                                <td>Anmol Yadav </td>
                                <td>Business Executive</td>
                                <td>Eris Lifescience Pvt. Ltd.</td>
                            </tr>
                            <tr>
                                <td>16.</td>
                                <td>Mohd Saif</td>
                                <td>Business Executive</td>
                                <td>Eris Lifescience Pvt. Ltd.</td>
                            </tr>
                            <tr>
                                <td>17.</td>
                                <td>Manas Prakash Tiwari </td>
                                <td>Business Executive</td>
                                <td>Eris Lifescience Pvt. Ltd.</td>
                            </tr>
                            <tr>
                                <td>18.</td>
                                <td>Ritik Raj</td>
                                <td>Marketing Executive</td>
                                <td>Medical Representative</td>
                            </tr>
                            <tr>
                                <td>19.</td>
                                <td>Ashutosh Maurya</td>
                                <td>Medical Representative</td>
                                <td>Alembic Pharmaceutical Pvt. Ltd.</td>
                            </tr>
                            <tr>
                                <td>20.</td>
                                <td>Manish Kumar </td>
                                <td>Production</td>
                                <td>Alembic Pharmaceutical Pvt. Ltd.</td>
                            </tr>
                            <tr>
                                <td>21.</td>
                                <td>Sumit Singh </td>
                                <td>Production</td>
                                <td>Alembic Pharmaceutical Pvt. Ltd.</td>
                            </tr>
                            <tr>
                                <td>22.</td>
                                <td>Srajal Gupta</td>
                                <td>Quality Control</td>
                                <td>Alembic Pharmaceutical Pvt. Ltd.</td>
                            </tr>
                            <tr>
                                <td>23.</td>
                                <td>Ravi Prakash Singh</td>
                                <td>Production</td>
                                <td>Alembic Pharmaceutical Pvt. Ltd.</td>
                            </tr>
                            <tr>
                                <td>24.</td>
                                <td>Raj Yadav</td>
                                <td>Quality Control</td>
                                <td>Alembic Pharmaceutical Pvt. Ltd.</td>
                            </tr>
                            <tr>
                                <td>25.</td>
                                <td>Shivam Singh </td>
                                <td>Production</td>
                                <td>Alembic Pharmaceutical Pvt. Ltd.</td>
                            </tr>
                            <tr>
                                <td>26.</td>
                                <td>Aftab Alam</td>
                                <td>Quality Control</td>
                                <td>Alembic Pharmaceutical Pvt. Ltd.</td>
                            </tr>
                            <tr>
                                <td>27.</td>
                                <td>Neetendra Pratap Singh</td>
                                <td>Production</td>
                                <td>Alembic Pharmaceutical Pvt. Ltd.</td>
                            </tr>                            
                            <tr>
                                <td>28.</td>
                                <td>Shivam</td>
                                <td>Production</td>
                                <td>Alembic Pharmaceutical Pvt. Ltd.</td>
                            </tr>
                            <tr>
                                <td>29.</td>
                                <td>Sandeep Kesharwani</td>
                                <td>Production</td>
                                <td>Alembic Pharmaceutical Pvt. Ltd.</td>
                            </tr>
                            <tr>
                                <td>30.</td>
                                <td>Deepak Sharma</td>
                                <td>Production</td>
                                <td>Alembic Pharmaceutical Pvt. Ltd.</td>
                            </tr>
                            <tr>
                                <td>31.</td>
                                <td>Vikash Bharti </td>
                                <td>Production</td>
                                <td>Alembic Pharmaceutical Pvt. Ltd.</td>
                            </tr>
                            <tr>
                                <td>32.</td>
                                <td>Arman Ali</td>
                                <td>Production</td>
                                <td>Alembic Pharmaceutical Pvt. Ltd.</td>
                            </tr>
                            <tr>
                                <td>33.</td>
                                <td>Priyanshu Nayak</td>
                                <td>Production</td>
                                <td>Alembic Pharmaceutical Pvt. Ltd.</td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                    <div class="col-lg-4">
                        <div class="sidebar">                          
                          <div class="common-section-item">
                            <div class="card">
                              <div class="card-body">
                                <h4 class="title-bg title-bg-default">Placement</h4>
                                <ul class="sidebar-links">
                                    <li><Link to={'/PlacementRecord202526'}>Placement Record 2024-25</Link></li>
                                    <li><Link to={'/PlacementRecord202324'}>Placement Record 2023-24</Link></li>
                                    <li><Link to={'/PlacementRecord2023'}>Placement Record 2022-23</Link></li>                                    
                                    <li><Link to={'/PlacementRecord201617'}>Placement Record 2016-17</Link></li>                                   
                                    <li><Link to={'/PlacmentGraph'}>Placment Graph</Link></li>
                                </ul>
                              </div>
                            </div>
                          </div>                        
                        </div>
                    </div>
              </div>
          </div>
      </section>
  </>
  )
}

export default PlacementRecord202526
